import React, { useEffect, useRef, useState } from 'react';
import Container from '../../components/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DataFetching from "../../helper/DataFetching";
import renderDataTable from "../../helper/renderDataTable";
import Loading from "../../components/Loading";
import { formatMoment } from '../../helper/CommonFunction';
import Breadcrumb from '../../components/Breadcrumb';
import { EyeIcon } from '@heroicons/react/24/outline';


const Users = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);
    const [pageOpen, setPageOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);

    /* ================= FETCH ALL USERS ================= */
    const fetchData = async () => {
        setPending(true);

        const body = {
            page: currentPage - 1,
            perpage: pageLimit,
            type: "", // ✅ ALL USERS
            user_id: "",
            name: "",
            email: "",
            cell: "",
            fromDate: "",
            toDate: "",
        };

        DataFetching(
            setPending,
            '/user_list.php',
            'POST',
            token,
            dispatch,
            navigate,
            setFilteredData,
            setTotalPages,
            body,
            setResetSearch,
            resetSearch
        );
    };

    useEffect(() => {
        if (!resetSearch) return;
        fetchData();
    }, [currentPage, pageLimit, location, resetSearch]);

    /* ================= TABLE COLUMNS (ONLY REQUIRED) ================= */
    const column = [
        {
            name: 'User ID',
            selector: row => row.id,
            width: '10%',
        },
        {
            name: 'Name',
            selector: row => row.full_name,
        },
        {
            name: 'Email',
            selector: row => row.email,
        },
        {
            name: 'Created Date',
            selector: row => <span>{formatMoment(row.created_date)}</span>,
            width: '18%',
        },
        // inside column
        {
            name: 'Action',
            cell: (row) => (
                <button
                    className="flex items-center justify-center w-8 h-8 
                       rounded-md bg-orange-600 hover:bg-orange-700"
                    title="View User"
                    onClick={() => navigate(`/Reconcilationsview/view/${row.id}`)}
                >
                    <EyeIcon className="w-5 h-5 text-white" />
                </button>
            ),
            width: '10%',
            center: true,
        }

    ];

    if (pageOpen) return <Loading />;

    return (
        <>
            <Breadcrumb pageName="Reconcilations" />

            <Container>
                <div className="border-2 border-[#ddddddbe] w-full">
                    <div className="p-3">

                        {/* ===== TABLE ===== */}
                        <div className="py-3">
                            {renderDataTable(
                                filteredData,
                                column,
                                pending,
                                currentPage,
                                setPageLimit,
                                setCurrentPage,
                                totalPages,
                                pageLimit,
                                setResetSearch,
                                dispatch,
                                navigate
                            )}
                        </div>

                    </div>
                </div>
            </Container>
        </>
    );
};

export default Users;
